import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_BUSINESS_REPORT: (businessId, yearsFromNow) => ({ businessId, yearsFromNow }),
    API: {
      GET_BUSINESS_REPORT: apiResourceActionCreator('businessReport')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.get(`${API_ENDPOINT}/reports/businesses/${payload.businessId}/${payload.yearsFromNow}`, authToken, action.admin.api.getBusinessReport)

function* getBusinessReport(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'getBusinessReport',
  action: action,
  sagas: getBusinessReport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingReport: true
    }),
    success: (state, action) => ({
      ...state,
      isFetchingReport: false,
      businessReport: action.payload.businessReport
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingReport: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getBusinessReport.js